/* LAMM BreezeDuo — lm-scripts.js */

// --- REVEAL on scroll ---
(function(){
  var els = document.querySelectorAll('.lm-reveal');
  if(!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('lm-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  els.forEach(function(el){ io.observe(el); });
})();

// --- COUNTDOWN ---
(function(){
  var el = document.getElementById('lm-countdown');
  if(!el) return;
  var key = 'lm_cd_end';
  var end = localStorage.getItem(key);
  if(!end || Date.now() > +end){
    end = Date.now() + (3*3600 + 47*60 + 23)*1000;
    localStorage.setItem(key, end);
  }
  function tick(){
    var diff = Math.max(0, (+end - Date.now()) / 1000 | 0);
    var h = (diff/3600|0), m = (diff%3600/60|0), s = diff%60;
    el.textContent = [h,m,s].map(function(n){ return String(n).padStart(2,'0'); }).join(':');
    if(diff > 0) requestAnimationFrame(tick);
  }
  tick();
})();

// --- GALLERY thumbnails ---
document.addEventListener('click', function(e){
  var thumb = e.target.closest('.lm-thumb');
  if(!thumb) return;
  var main = document.getElementById('lm-main-img');
  if(main && thumb.dataset.full){ main.src = thumb.dataset.full; }
  thumb.closest('.lm-galeria__thumbs') && thumb.closest('.lm-galeria__thumbs').querySelectorAll('.lm-thumb').forEach(function(t){ t.classList.remove('is-active'); });
  thumb.classList.add('is-active');
});

// --- FAQ accordion ---
document.addEventListener('click', function(e){
  var q = e.target.closest('.lm-faq-item__q');
  if(!q) return;
  var item = q.closest('.lm-faq-item');
  item.classList.toggle('is-open');
});

// --- COUNTUP ---
(function(){
  var els = document.querySelectorAll('[data-countup]');
  if(!els.length) return;
  var io2 = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var el = e.target, target = +el.dataset.countup, suffix = el.dataset.suffix||'';
      var start = Date.now(), dur = 1800;
      function frame(){
        var p = Math.min(1,(Date.now()-start)/dur);
        el.textContent = Math.round(p*target) + suffix;
        if(p<1) requestAnimationFrame(frame);
      }
      frame();
      io2.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function(el){ io2.observe(el); });
})();
